var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cache-manager-page" },
    [
      _c("div", { staticClass: "header" }, [
        _c("h2", [
          _c("i", { staticClass: "material-icons" }, [_vm._v("storage")]),
          _vm._v(
            "\n            " + _vm._s(_vm.$t("Cache Yönetimi")) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-actions" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { primary: "" },
                on: {
                  click: function ($event) {
                    _vm.showCreateCacheModal = true
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("Yeni Cache Oluştur")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filters-section" }, [
        _c(
          "div",
          { staticClass: "filter-row" },
          [
            _c("a-input-search", {
              staticStyle: { width: "300px" },
              attrs: {
                placeholder: _vm.$t(
                  "Key ara (wildcard destekli: *chat*, chat*, *chat)"
                ),
              },
              on: { search: _vm.fetchCaches },
              model: {
                value: _vm.filters.keyPattern,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "keyPattern", $$v)
                },
                expression: "filters.keyPattern",
              },
            }),
            _vm._v(" "),
            _c("CustomPicker", {
              attrs: {
                items: _vm.typeOptions,
                idKey: "value",
                labelKey: "label",
                placeholder: _vm.$t("Cache Tipi"),
              },
              on: { input: _vm.fetchCaches },
              model: {
                value: _vm.filters.type,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "type", $$v)
                },
                expression: "filters.type",
              },
            }),
            _vm._v(" "),
            _c("CustomPicker", {
              attrs: {
                items: _vm.actorTypeOptions,
                idKey: "value",
                labelKey: "label",
                placeholder: _vm.$t("Aktör Tipi"),
              },
              on: { input: _vm.onActorTypeChange },
              model: {
                value: _vm.filters.actorType,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "actorType", $$v)
                },
                expression: "filters.actorType",
              },
            }),
            _vm._v(" "),
            _vm.filters.actorType === "automation"
              ? _c("CustomPicker", {
                  attrs: {
                    items: _vm.automationOptions,
                    idKey: "_id",
                    labelKey: "name",
                    placeholder: _vm.$t("Otomasyon Seç"),
                  },
                  on: { input: _vm.fetchCaches },
                  model: {
                    value: _vm.filters.actorId,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "actorId", $$v)
                    },
                    expression: "filters.actorId",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filters.actorType === "chatbot"
              ? _c("CustomPicker", {
                  attrs: {
                    items: _vm.chatbotOptions,
                    idKey: "_id",
                    labelKey: "title",
                    placeholder: _vm.$t("Chatbot Seç"),
                  },
                  on: { input: _vm.fetchCaches },
                  model: {
                    value: _vm.filters.actorId,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "actorId", $$v)
                    },
                    expression: "filters.actorId",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.filters.actorType === "user"
              ? _c("CustomPicker", {
                  attrs: {
                    items: _vm.userOptions,
                    idKey: "_id",
                    labelKey: "name",
                    placeholder: _vm.$t("Kullanıcı Seç"),
                  },
                  on: { input: _vm.fetchCaches },
                  model: {
                    value: _vm.filters.actorId,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "actorId", $$v)
                    },
                    expression: "filters.actorId",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.clearFilters } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("clear")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("Filtreleri Temizle")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.selectionMode
          ? _c("div", { staticClass: "filter-row" }, [
              _c(
                "div",
                { staticClass: "selection-info" },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.selectedCaches.length) + " cache seçildi"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { ghost: "" },
                      on: { click: _vm.exitSelectionMode },
                    },
                    [_vm._v(_vm._s(_vm.$t("İptal")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bulk-actions" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { danger: "" },
                      on: { click: _vm.bulkDeleteCaches },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("delete"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("Seçilileri Sil")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      on: {
                        click: function ($event) {
                          _vm.showBulkExtendModal = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("schedule"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("Seçililerin Süresini Uzat")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    { on: { click: _vm.bulkMakeNeverExpire } },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("all_inclusive"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("Seçilileri Süresiz Yap")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.filters.actorType && _vm.filters.actorId
          ? _c(
              "div",
              { staticClass: "filter-row" },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: { danger: "" },
                    on: { click: _vm.deleteAllActorCaches },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("delete_sweep"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Bu Aktörün Tüm Cache'lerini Sil")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c("a-table", {
            attrs: {
              columns: _vm.columns,
              "data-source": _vm.caches,
              pagination: _vm.tablePagination,
              loading: _vm.loading,
              "row-key": function (record) {
                return record._id
              },
              "row-selection": _vm.rowSelection,
              "row-class-name": _vm.getRowClassName,
              "custom-row": _vm.customRow,
              scroll: { x: 1500 },
              size: "small",
              locale: {
                emptyText: _vm.$t("Henüz cache bulunmuyor"),
              },
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "empty",
                fn: function () {
                  return [
                    _c("div", { staticClass: "empty-state" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("inbox"),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("Henüz cache bulunmuyor"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showCreateCacheModal || _vm.showEditCacheModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.editingCache
                  ? _vm.$t("Cache Düzenle")
                  : _vm.$t("Yeni Cache Oluştur"),
                "show-title": "",
                "show-footer": false,
              },
              on: { cancel: _vm.closeCacheModal },
            },
            [
              _c("div", { staticClass: "cache-form" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("Cache Key")))]),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        placeholder: _vm.$t("Örnek: user_session_123"),
                        disabled: !!_vm.editingCache,
                      },
                      model: {
                        value: _vm.cacheForm.key,
                        callback: function ($$v) {
                          _vm.$set(_vm.cacheForm, "key", $$v)
                        },
                        expression: "cacheForm.key",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("Cache Value")))]),
                    _vm._v(" "),
                    _vm.cacheForm.dataType === "string"
                      ? [
                          _c("a-input", {
                            attrs: { placeholder: _vm.$t("String değer") },
                            model: {
                              value: _vm.cacheForm.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.cacheForm, "value", $$v)
                              },
                              expression: "cacheForm.value",
                            },
                          }),
                        ]
                      : _vm.cacheForm.dataType === "number"
                      ? [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            model: {
                              value: _vm.cacheForm.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.cacheForm, "value", $$v)
                              },
                              expression: "cacheForm.value",
                            },
                          }),
                        ]
                      : _vm.cacheForm.dataType === "boolean"
                      ? [
                          _c("a-switch", {
                            model: {
                              value: _vm.cacheForm.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.cacheForm, "value", $$v)
                              },
                              expression: "cacheForm.value",
                            },
                          }),
                        ]
                      : _vm.cacheForm.dataType === "date"
                      ? [
                          _c("a-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: { "show-time": "" },
                            model: {
                              value: _vm.cacheForm.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.cacheForm, "value", $$v)
                              },
                              expression: "cacheForm.value",
                            },
                          }),
                        ]
                      : _vm.cacheForm.dataType === "objectid_user"
                      ? [
                          _c("CustomPicker", {
                            attrs: {
                              items: _vm.userOptions,
                              idKey: "_id",
                              labelKey: "name",
                              placeholder: _vm.$t("Kullanıcı Seç"),
                            },
                            model: {
                              value: _vm.cacheForm.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.cacheForm, "value", $$v)
                              },
                              expression: "cacheForm.value",
                            },
                          }),
                        ]
                      : [
                          _c("v-jsoneditor", {
                            attrs: {
                              options: _vm.jsonEditorOptions,
                              height: "300px",
                            },
                            model: {
                              value: _vm.cacheFormValueObject,
                              callback: function ($$v) {
                                _vm.cacheFormValueObject = $$v
                              },
                              expression: "cacheFormValueObject",
                            },
                          }),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("Data Type")))]),
                    _vm._v(" "),
                    _c("CustomPicker", {
                      attrs: {
                        items: _vm.dataTypeOptions,
                        idKey: "value",
                        labelKey: "label",
                      },
                      model: {
                        value: _vm.cacheForm.dataType,
                        callback: function ($$v) {
                          _vm.$set(_vm.cacheForm, "dataType", $$v)
                        },
                        expression: "cacheForm.dataType",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("Cache Tipi")))]),
                    _vm._v(" "),
                    _c("CustomPicker", {
                      attrs: {
                        items: _vm.typeOptions,
                        idKey: "value",
                        labelKey: "label",
                      },
                      model: {
                        value: _vm.cacheForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.cacheForm, "type", $$v)
                        },
                        expression: "cacheForm.type",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("Geçerlilik Süresi")))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "expires-config" },
                    [
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.expiresMode,
                            callback: function ($$v) {
                              _vm.expiresMode = $$v
                            },
                            expression: "expiresMode",
                          },
                        },
                        [
                          _c("a-radio", { attrs: { value: "never" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("Hiçbir zaman expire olmasın"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("a-radio", { attrs: { value: "duration" } }, [
                            _vm._v(_vm._s(_vm.$t("Süre belirt"))),
                          ]),
                          _vm._v(" "),
                          _c("a-radio", { attrs: { value: "date" } }, [
                            _vm._v(_vm._s(_vm.$t("Tarih belirt"))),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.expiresMode === "duration"
                        ? _c(
                            "div",
                            { staticClass: "duration-input" },
                            [
                              _c("a-input-number", {
                                attrs: { min: 1 },
                                model: {
                                  value: _vm.expiresDuration.value,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.expiresDuration, "value", $$v)
                                  },
                                  expression: "expiresDuration.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "120px" },
                                  model: {
                                    value: _vm.expiresDuration.unit,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.expiresDuration, "unit", $$v)
                                    },
                                    expression: "expiresDuration.unit",
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "minutes" } },
                                    [_vm._v(_vm._s(_vm.$t("Dakika")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "hours" } },
                                    [_vm._v(_vm._s(_vm.$t("Saat")))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "days" } },
                                    [_vm._v(_vm._s(_vm.$t("Gün")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.expiresMode === "date"
                        ? _c(
                            "div",
                            [
                              _c("a-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: { "show-time": "" },
                                model: {
                                  value: _vm.cacheForm.expiresAt,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.cacheForm, "expiresAt", $$v)
                                  },
                                  expression: "cacheForm.expiresAt",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-actions" },
                  [
                    _c("SupsisButton", { on: { click: _vm.closeCacheModal } }, [
                      _vm._v(_vm._s(_vm.$t("İptal"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "", loading: _vm.saving },
                        on: { click: _vm.saveCache },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.editingCache
                                ? _vm.$t("Güncelle")
                                : _vm.$t("Oluştur")
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showValueModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title:
                  "Cache Değeri: " + _vm.$_.get(_vm.viewingCache, "key", ""),
                "show-title": "",
                "show-footer": false,
                "class-name": "value-viewer-modal",
              },
              on: {
                cancel: function ($event) {
                  _vm.showValueModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "value-viewer" }, [
                _c("div", { staticClass: "value-meta" }, [
                  _c("span", [
                    _c("strong", [_vm._v("Type:")]),
                    _vm._v(" " + _vm._s(_vm.$_.get(_vm.viewingCache, "type"))),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _c("strong", [_vm._v("Data Type:")]),
                    _vm._v(
                      " " + _vm._s(_vm.$_.get(_vm.viewingCache, "dataType"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "value-content" },
                  [
                    ["json", "array", "mixed"].includes(
                      _vm.$_.get(_vm.viewingCache, "dataType")
                    )
                      ? _c("v-jsoneditor", {
                          attrs: {
                            options: _vm.jsonEditorViewOptions,
                            height: "500px",
                          },
                          model: {
                            value: _vm.viewingCacheValue,
                            callback: function ($$v) {
                              _vm.viewingCacheValue = $$v
                            },
                            expression: "viewingCacheValue",
                          },
                        })
                      : _c("div", { staticClass: "simple-value" }, [
                          _vm._v(_vm._s(_vm.$_.get(_vm.viewingCache, "value"))),
                        ]),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showBulkExtendModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("Toplu Süre Uzatma"),
                "show-title": "",
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showBulkExtendModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "bulk-extend-form" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.selectedCaches.length) +
                      " cache'in geçerlilik süresi uzatılacak."
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("Yeni Geçerlilik Süresi"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "duration-input" },
                    [
                      _c("a-input-number", {
                        attrs: { min: 1 },
                        model: {
                          value: _vm.bulkExpiresDuration.value,
                          callback: function ($$v) {
                            _vm.$set(_vm.bulkExpiresDuration, "value", $$v)
                          },
                          expression: "bulkExpiresDuration.value",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "120px" },
                          model: {
                            value: _vm.bulkExpiresDuration.unit,
                            callback: function ($$v) {
                              _vm.$set(_vm.bulkExpiresDuration, "unit", $$v)
                            },
                            expression: "bulkExpiresDuration.unit",
                          },
                        },
                        [
                          _c(
                            "a-select-option",
                            { attrs: { value: "minutes" } },
                            [_vm._v(_vm._s(_vm.$t("Dakika")))]
                          ),
                          _vm._v(" "),
                          _c("a-select-option", { attrs: { value: "hours" } }, [
                            _vm._v(_vm._s(_vm.$t("Saat"))),
                          ]),
                          _vm._v(" "),
                          _c("a-select-option", { attrs: { value: "days" } }, [
                            _vm._v(_vm._s(_vm.$t("Gün"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-actions" },
                  [
                    _c(
                      "SupsisButton",
                      {
                        on: {
                          click: function ($event) {
                            _vm.showBulkExtendModal = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("İptal")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "", loading: _vm.saving },
                        on: { click: _vm.bulkExtendCaches },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("Uzat")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }